import { makeSizeTokens } from '@utils/react/selectors';

const imageCaptionSize = makeSizeTokens("--image-caption", {
  height: "0px",
  width: "0px"
});
const textSize = makeSizeTokens("--text", {
  height: "0px",
  width: "0px"
});
const wrapper = "k9qw14frglw";
const image = "k9qi1yj4txc";
const graphic = "k9qgpmwa1h";
const text = "k9qtieq7s5";

export { graphic, image, imageCaptionSize, text, textSize, wrapper };
import "./_split-component.style.linaria.module.css";
//# sourceMappingURL=_split-component.style.js.map
